export default "__VITE_PUBLIC_ASSET__035a56ea__"